import { ChevronDown, Sparkles } from "lucide-react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import type { Model } from "@/types/api"

interface ModelPickerProps {
  models: Model[]
  selectedId: string | null
  onSelect: (id: string) => void
}

export function ModelPicker({ models, selectedId, onSelect }: ModelPickerProps) {
  // Gateway unreachable or a single model — a picker would be noise
  if (models.length < 2) return null

  const selected = models.find((m) => m.id === selectedId)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Select model"
          title={selected ? `Model: ${selected.label}` : "Select model"}
          className="flex shrink-0 items-center gap-1 self-end rounded-lg px-2 py-2 text-xs text-fg3 transition-colors hover:bg-elevated hover:text-foreground"
        >
          <Sparkles className="size-3.5" />
          <span className="max-w-32 truncate">{selected?.label ?? "Model"}</span>
          <ChevronDown className="size-3" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="start" side="top" className="max-h-80 w-60 overflow-y-auto">
        <DropdownMenuLabel className="text-fg3">Model</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuRadioGroup value={selectedId ?? ""} onValueChange={onSelect}>
          {/* No provider subtitle: LiteLLM reports owned_by="openai" for every
              deployment regardless of the real vendor, so showing it would lie. */}
          {models.map((model) => (
            <DropdownMenuRadioItem key={model.id} value={model.id} className="cursor-pointer">
              <span className="truncate">{model.label}</span>
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
